export enum MimeType {
    EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    SVG_BLOB = 'image/svg+xml;charset=utf-8',
    PDF = 'application/pdf',
    DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    MS_WORD = 'application/msword',
    TEXT = 'text/plain',
    JSON = 'application/json',
    JSON_API = 'application/vnd.api+json',
    ZIP = 'application/zip',
    TIFF = 'image/tiff',
    JPEG = 'image/jpeg',
    PNG = 'image/png',
    WEBP = 'image/webp'
}
